import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { ShieldOff, X } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Admin-only "reject verification request" dialog with mandatory note.
 * Controlled by the parent via `open` / `onCancel` / `onSubmit`.
 */
export default function RejectDialog({ open, note, onNoteChange, onCancel, onSubmit, busy }) {
    const { t } = useTranslation();
    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
            <DialogContent className="rounded-sm" data-testid="reject-dialog">
                <DialogHeader>
                    <DialogTitle>{t("admin_dealers.reject_title")}</DialogTitle>
                    <DialogDescription>
                        {t("admin_dealers.reject_description")}
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-2">
                    <label className="text-xs font-bold uppercase tracking-wider text-gray-500">{t("admin_dealers.reject_note_label")}</label>
                    <Textarea
                        value={note}
                        onChange={(e) => onNoteChange(e.target.value)}
                        placeholder={t("admin_dealers.reject_note_placeholder")}
                        rows={4}
                        className="rounded-sm"
                        data-testid="reject-note-input"
                    />
                    <p className="text-xs text-gray-500">{t("admin_dealers.reject_note_hint")}</p>
                </div>
                <DialogFooter>
                    <Button type="button" variant="outline" onClick={onCancel} className="rounded-sm" data-testid="reject-cancel">
                        <X className="w-4 h-4 mr-1" /> {t("admin_dealers.reject_cancel")}
                    </Button>
                    <Button
                        type="button"
                        onClick={onSubmit}
                        disabled={!note.trim() || busy}
                        className="bg-red-600 hover:bg-red-700 text-white rounded-sm font-bold"
                        data-testid="reject-submit"
                    >
                        <ShieldOff className="w-4 h-4 mr-1" /> {t("admin_dealers.reject_submit")}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
